@for (option of toggles; track option) {
  <h5 class="accountOptions__header">{{ option.label }}</h5>
  <div class="accountOptions__item">
    <div>
      <pp-select
        [ppItems]="option.items"
        [ppSelectedItem]="option.items[option.index]"
        (ppSelectItem)="selectItem(option, $event)"
        [ppNoSearchBar]="true"
        require
        >
        <ng-container selected>
          @if (option.index !== -1) {
            <span class="accountSettings__select-content">
              {{ option.items[option.index].label }}
            </span>
          }
          @if (option.index === -1) {
            <span class="accountSettings__select-placeholder">
              {{ option.placeholder }}
            </span>
          }
        </ng-container>
      </pp-select>
    </div>
  </div>
}
